import React from "react";
import { Element } from "react-scroll";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Hero/Navbar/Navbar";
import Header from "./components/Hero/Header/Header";
import Testimonial from "./components/Testimonial/Testimonial"
import Demo from "./components/Demo/Demo"
import Feature from "./components/Feature/Feature"
import Community from "./components/Community/Community"
import Pricing from "./components/Pricing/Pricing"
import About from "./components/About/About"
import Footer from "./components/Footer/Footer";
import Download from "./components/Download/Download";
import Services from "./components/Service/Service";
import Team from "./components/Team/Team"
import Contact from "./components/ContactUs/ContactUs";
import Privacy from "./components/Privacy/Privacy";
import Tracking from './components/Tracking/Tracking';
import AboutPage from "./components/AboutPage/AboutPage";
import ContactPage from "./components/ContactPage/ContactPage";
import FeaturePage from "./components/FeaturePage/FeaturePage";
import Quiz from './components/Quiz/Quiz.js'
import Top from "./components/Top.js"
import Qr from "./components/Qr/Qr";
import QuizAttempt from "./components/QuizAttempt/QuizAttempt";
import NotFound from "./components/NotFound/NotFound";
import Login from "./components/Login/Login";
import Admin from "./components/Admin/Admin";



const CommonLayout = () => (
  <>
    <Navbar />
    <Header />
    <About/>
    <Feature/>
    <Tracking/>
    <Qr/>
    {/* <Pricing/>
    <Team/>
    <Testimonial/> */}
    <Contact/>
    {/* <Top/> */}
    {/* <Services/> */}
   
  
    {/* <Demo/> */}
    {/* <Download/>
    <Feature/>
    <Community/>
    */}
   
    <Footer />
  
  </>
);

const App = () => (
  <BrowserRouter>
    <ScrollToTop /> {/* This will scroll to top on route changes */}
    <Routes>
      <Route path="/" element={<CommonLayout />} />
        {/* <Route path="/quiz/:id" element={<QuizAttempt />} /> */}
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/feature" element={<FeaturePage />} />
      <Route path="/feedback" element={<ContactPage />} />
      <Route path="/feedback" element={<ContactPage />} />
      <Route path="/quiz" element={<Quiz />} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<Admin />} />
      

      <Route path="*" element={<NotFound />} />
    </Routes>
  </BrowserRouter>
);

export default App;
